// extracted by mini-css-extract-plugin
export var wrapper = "relatedContentCell-module--wrapper--UozIP";
export var type = "relatedContentCell-module--type---IFbv";
export var title = "relatedContentCell-module--title--kLN2p";
export var container = "relatedContentCell-module--container--rBH7t";
export var textContainer = "relatedContentCell-module--textContainer--BfcT7";
export var circleButton = "relatedContentCell-module--circleButton--Nvi92";
export var slideUp = "relatedContentCell-module--slideUp--SIl94";
export var slideUpLarge = "relatedContentCell-module--slideUpLarge--ml4Gs";